// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___lxYm2","filtersContainer":"filtersContainer___Y2klh"};